module.exports = __webpack_public_path__ + "static/francisco-c601a96ed113733640ea26ffa991e2cb.png";